import {
    FETCH_COMPANY_PENDING,
    FETCH_COMPANY_SUCCESS,
    FETCH_COMPANY_ERROR,
    UPDATE_COMPANY,
    CREATE_COMPANY,
    FETCH_COMPANY_SETTINGS,
    UPDATE_COMPANY_SETTINGS
} from '../../actions/company';

const initialState = {
    pending: false,
    company: null,
    companySettings: null,
    error: null,
    creationStatus: null
}

const companyReducer = (state = initialState, action) => {
    switch(action.type) {

        case FETCH_COMPANY_PENDING: 
            return {
                ...state,
                pending: true
            }
        case FETCH_COMPANY_SUCCESS:
            return {
                ...state,
                pending: false,
                company: action.company
            }
        case FETCH_COMPANY_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        
        case FETCH_COMPANY_SETTINGS:
            return {
                ...state,
                companySettings: action.companySettings,
                pending: false
            }
        
        case UPDATE_COMPANY:
            return {
                ...state,
                company: action.company
            }

        case CREATE_COMPANY:
            console.log(action, "action CREATE_COMPANY");
            return {
                ...state,
                company: action.status === "success" ? action.company : state.company,
                creationStatus: action.status
            }
        
        case UPDATE_COMPANY_SETTINGS:
            return {
                ...state,
                companySettings: action.companySettings
            }

        default: 
            return state;
    }
}
export default companyReducer;